export function resolveTemplateIdForUser(selectedTemplateMap, userId, batchTemplateId) {
  return String(selectedTemplateMap?.[userId] || batchTemplateId || '').trim();
}

export function getSelectedBatchUserIds(selectedBatchUserIds) {
  return Array.from(selectedBatchUserIds || []);
}

export function normalizeTemplatePreviewRows(items) {
  return Array.isArray(items) ? items : [];
}

export function buildTemplateSelectOptions(templates = []) {
  return (Array.isArray(templates) ? templates : []).map((template) => ({
    id: template?.id || '',
    name: template?.name || '',
  }));
}

export function buildTemplateSelectPlaceholder(mode, templateLoading) {
  if (templateLoading) return '模板加载中...';
  if (mode === 'autoMatch') return '自动匹配模板';
  if (mode === 'single') return '选择模板';
  return '请选择模板';
}

export function buildNextSelectedBatchUserIds(selectedBatchUserIds, userId) {
  const next = new Set(selectedBatchUserIds || []);
  if (next.has(userId)) next.delete(userId);
  else next.add(userId);
  return next;
}

export function validateSingleTemplateAction(templateId, missingTemplateMessage) {
  if (!templateId) return missingTemplateMessage;
  return '';
}

export function validateBatchTemplateAction({
  userIds,
  batchTemplateId,
  missingUsersMessage,
  missingTemplateMessage,
}) {
  if (!Array.isArray(userIds) || userIds.length === 0) return missingUsersMessage;
  if (!batchTemplateId) return missingTemplateMessage;
  return '';
}

export async function runTemplateActionWithLoading({
  setLoading,
  setError,
  execute,
  onSuccess,
}) {
  setLoading(true);
  setError('');
  try {
    const res = await execute();
    if (res?.error) {
      setError(res.error);
      return { ok: false, res };
    }
    if (typeof onSuccess === 'function') {
      await onSuccess(res);
    }
    return { ok: true, res };
  } catch (error) {
    setError(error?.message || '操作失败');
    return { ok: false, res: { error: error?.message || '操作失败' } };
  } finally {
    setLoading(false);
  }
}
